import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import PageHero from '../components/PageHero';

const Projects: React.FC = () => {
  const { t } = useTranslation('projects');
  return (
    <div className="min-h-screen pt-24">
      <section className="page-section relative">
        <div className="container mx-auto px-6">
          <PageHero title={t('heroTitle')} />
          <motion.div
            initial={{ opacity: 0, y: 28 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.75, delay: 0.1 }}
            className="page-max mt-8"
          >
            <div
              className="rounded-2xl border border-primary-500/25 bg-dark-800/40 p-6 text-lg font-medium leading-relaxed text-dark-300 shadow-inner backdrop-blur-sm md:p-8"
              dangerouslySetInnerHTML={{ __html: t('projectsContent') }}
            />

            {/*
              Již brzy zde naleznete mé nejnovější, nejpropracovanější a nejinovativnější projekty, na kterých momentálně intenzivně pracuji. 🌟 Každý z nich vzniká s důrazem na kvalitu, originalitu a praktičnost, aby byl přínosem nejen pro mě, ale i pro vás – ať už jste vývojář, tvůrce obsahu, nebo prostě jen někdo, kdo má rád moderní technologie a nápady, které dávají smysl. <br /><br />
 
              Tyto projekty zde nebudou pouze na ukázku. Budete si je moci stáhnout k volnému použití, abyste s nimi mohli dále pracovat podle svých představ. Chci, aby každý měl možnost využít je naplno – upravit je, rozšířit, nebo je začlenit do vlastních projektů. Moje filozofie je jednoduchá: když něco tvořím, chci, aby to mohlo pomoci i ostatním. 💡 <br /><br />
 
              Každý projekt bude pečlivě popsán, s uvedením všech důležitých detailů, návodů a možností využití. Tím vám chci usnadnit práci a zajistit, že přesně pochopíte, jak s projektem naložit a co všechno z něj můžete vytěžit. 📘 <br /><br />
 
              A pokud byste si přáli, mohu vám navíc projekt nastavit přímo na hosting, abyste se nemuseli starat o žádné technické záležitosti. Celý proces nasazení, konfigurace i otestování provedu za vás – vy tak dostanete hotové řešení, které bude okamžitě připravené k použití. 💻 <br /><br />
 
              ✨ Už brzy se tedy můžete těšit na místo plné nápadů, inspirace a technických řešení, která vám otevřou nové možnosti. Připravte se – tohle bude teprve začátek! 🚀*/}
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Projects;